module.exports = {
  /* 01.General */
  "chat.end":"أعد بدء محادثة الدردشة الخاصة بك",
  "chat.endall":"نهاية المحادثة",
  "chat.cancel":"يلغي",
  "chat.cookie":"يستخدم هذا المساعد الرقمي ملفات تعريف الارتباط لضمان حصولك على أفضل تجربة",
  "chat.learn":"يتعلم أكثر",
  "chat.minimize":"تصغير",
  "chat.hide":"يغلق",
  "chat.hidebot.text":"إغلاق سيجعل الصورة الرمزية تختفي لمدة 15 دقيقة",
  "chat.hidebot":"إغلاق (إخفاء) الصورة الرمزية",
  "chat.restart":"اعادة البدء",
  "switch.language":"تبديل اللغة",
  "switch.property":"تبديل الممتلكات",
  "restart.converstation":"أعد تشغيل المحادثة",
  "chat.endtext":"هل أنت متأكد أنك تريد إنهاء الدردشة الحالية؟",
  "check.availabity":"التحقق من الصلاحية",
  "check.availabity.submit":"إرسال",
  "check.availabity.cancel":"يلغي",
  "check.availabity.adults":"الكبار ",
  "check.availabity.children":"أطفال",
  "check.availabity.child.age":"العمر - الطفل",
  "feedback.leave":"اترك تقييم للخدمة",
  "feedback.leave.message":"اترك رسالة",
};